import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { fetchOrgSampleWeddingStatus } from 'apollo/projects.query';
import APModal from 'components/Modal/APModal';
import CreateQuickProject from './CreateQuickProject';
import ProjectsSettings from './ProjectSettings';
import CreateSampleProjectModal from './CreateSampleProject';
import { CreateCustomTemplateProject } from './CreateCustomTemplateProject';
import './styles.scss';

const ProjectModal = ({ open, onClose, weddingId = null, updateWeddingChanges, pushNotification = null }) => {
  const [type, setType] = useState(-1);
  const [showProjectSettings, setShowProjectSettings] = useState(false);
  const [openCreateSampleProject, setOpenCreateSampleProject] = useState(false);
  const [finishedWeddingId, setFinishedWeddingId] = useState();
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [canCreateSample, setCanCreateSample] = useState(false);

  const topRef = useRef(null);

  const goToProject = (id) => {
    const _id = id ?? finishedWeddingId;
    window.location.href = `/app/project/${_id}/dashboard`;
  };

  const projectCreatedCallback = (data) => {
    const { createWedding, customTemplate } = data;
    const { wedding } = createWedding || {};
    const { id } = wedding || {};

    if (!customTemplate) {
      goToProject(id);
    } else {
      setFinishedWeddingId(id);
      setShowLoadingModal(true);
    }
  };

  useEffect(() => {
    if (!open) {
      setType(-1);
      setShowProjectSettings(false);
    } else if (weddingId !== null) {
      setShowProjectSettings(true);
    }

    const getSampleWeddingStatus = async () => {
      try {
        const dataStatus = await fetchOrgSampleWeddingStatus();
        const { sampleWeddingStatus } = dataStatus.me.organization;
        setCanCreateSample(sampleWeddingStatus === 'available' || sampleWeddingStatus === 'preparing');
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    };
    getSampleWeddingStatus();
  }, [open]);

  useEffect(() => {
    if (showProjectSettings) topRef.current?.scrollIntoView({ block: 'end' });
  }, [showProjectSettings]);

  const updateType = (value) => {
    setType(value);
  };

  const openCreateProject = () => {
    if (type === 0) {
      setOpenCreateSampleProject(true);
      onClose();
    } else {
      setShowProjectSettings(true);
    }
  };

  const title = weddingId ? 'Project Settings' : 'Create a new project.';
  const name = weddingId ? 'project-settings' : 'create-quick-project';

  return (
    <>
      <APModal
        open={open}
        title={title}
        name={name}
        className={clsx(
          showProjectSettings
            ? 'settings_project_modal__container'
            : 'create_quick_project_modal__container',
          canCreateSample && 'large',
        )}
        onClose={onClose}
      >
        {showProjectSettings ? (
          <ProjectsSettings
            type={type}
            weddingId={weddingId}
            updateWeddingChanges={updateWeddingChanges}
            pushNotification={pushNotification}
            projectCreatedCallback={projectCreatedCallback}
          />
        ) : (
          <CreateQuickProject
            type={type}
            updateType={updateType}
            openCreateProject={openCreateProject}
          />
        )}
      </APModal>
      <CreateSampleProjectModal
        open={openCreateSampleProject}
        onClose={() => {
          setOpenCreateSampleProject(false);
        }}
      />
      {showLoadingModal && (
        <CreateCustomTemplateProject
          show={showLoadingModal}
          goToProject={goToProject}
          projectId={finishedWeddingId}
        />
      )}
    </>
  );
};
ProjectModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  updateWeddingChanges: PropTypes.func,
};

ProjectModal.defaultProps = {};

export default ProjectModal;
